import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import UrlUtils from '../../../utils/url';
import { StyleColor, NewStyleColor } from '../../../utils/styles-constants';
import UserAgentUtils from '../../../utils/userAgent';
import { StoreState } from '../../../reducers';
import { GalleryInfosState } from '../../../containers/Gallery/reducer';
import { DownloadButtonVariants } from './styles';
import { requestWebDownloadItem, requestMobileAppDownload, downloadRecursively, downloadAll } from '../../../containers/DownloadManager/actions';
import Tooltip from '../../../components/Tooltip';
import { ActionButtonStyle, ActionButton } from '../../../utils/driveItem';
import Loader, { LoaderStep, LoaderType, LoaderStepName } from '../../../components/Loader';
import { DownloadMode } from '../../../containers/DownloadManager/reducer';
import StatsUtils from '../../../utils/statistics';
import { Translate } from 'react-redux-i18n';

const RESET_DELAY = 3000;

export interface DriveItemDownloadButtonProps {
	driveItems?: Api.DriveItem[];
	dispatch: Dispatch<StoreState>;
	style: ActionButtonStyle;
	action?: ActionButton;
	downloadAllButtonStatus: DownloadAllButtonStatus;
	galleryInfos: GalleryInfosState;
	isDownloading: boolean;
	isDownloadingAll: boolean;
	isDeletingAll: boolean;
	loaderStep: LoaderStep;
}

interface DriveItemDownloadButtonState {
	clicked: boolean;
}

export enum DownloadAllButtonStatus {
	DownloadAll = 'download_all',
	ContinueDownloading = 'continue_downloading',
	DownloadComplete = 'download_complete',
	Update = 'update',
}

class DriveItemDownloadButton extends React.Component<DriveItemDownloadButtonProps, DriveItemDownloadButtonState> {

	constructor(props: DriveItemDownloadButtonProps) {
		super(props);
		this.state = { clicked: false };
	}

	handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		const { driveItems, dispatch, galleryInfos, action, isDownloadingAll } = this.props;
		const { isMobileApp } = UserAgentUtils;

		if (driveItems) {
			if (action !== ActionButton.Update) {
				StatsUtils.trackDownload(driveItems);
			}
			const driveItemsIds = driveItems.map(driveItem => driveItem.id);

			if (!isMobileApp) {
				this.setState({ clicked: true });
				setTimeout(() => this.setState({ clicked: false }), RESET_DELAY);

				if (driveItems.length === 1) {
					dispatch(requestWebDownloadItem(driveItems[0]));
				} else {
					window.location.href = UrlUtils.getResourcesGroupUrl(galleryInfos.config, driveItemsIds);
				}
			} else {
				if (driveItems.length === 1) {
					dispatch(requestMobileAppDownload(driveItems[0], DownloadMode.Requested));
				} else {
					driveItemsIds.forEach(itemId => {
						dispatch(downloadRecursively(itemId, DownloadMode.Requested));
					});
				}
			}
		} else {
			if (!isDownloadingAll) {
				dispatch(downloadAll());
			}
		}
	}

	renderButtonContent = () => {
		const { style, action, isDownloading, loaderStep, isDownloadingAll, downloadAllButtonStatus } = this.props;
		const isPhone = UserAgentUtils.isPhone();

		if (style === ActionButtonStyle.Bar) {
			if (isDownloading) {
				return <Loader loaderStep={loaderStep ? loaderStep : { step: LoaderStepName.Downloading }} type={LoaderType.Button} />;
			}
			if (action === ActionButton.Update) {
				return isPhone ? Utils.getSvgIcon('iconset_update') : <Translate value="messages.update" />;
			} else {
				return <Translate value="messages.download" />;
			}
		} else if (style === ActionButtonStyle.Icon) {
			return Utils.getSvgIcon('iconset_uprez_download');
		} else if (style === ActionButtonStyle.ParametersPage) {
			if (isDownloadingAll) {
				return <Loader loaderStep={loaderStep ? loaderStep : { step: LoaderStepName.Downloading }} type={LoaderType.Button} />;
			}
			const message = 'messages.' + downloadAllButtonStatus || 'download_all';
			return <Translate value={message} />;
		} else {
			return;
		}
	}

	render() {
		const { action, style, isDownloading, downloadAllButtonStatus, isDeletingAll } = this.props;
		const { clicked } = this.state;

		const iconsColor = StyleColor.Black;
		const isDownloadCompleted = downloadAllButtonStatus === DownloadAllButtonStatus.DownloadComplete;
		const isFlickering = isDownloading || clicked;
		const tooltipId = Utils.generateId();
		const DownloadButton = DownloadButtonVariants[style];

		return !isDeletingAll ?
			(
				<DownloadButton
					onClick={!isDownloadCompleted && this.handleClick}
					isFlickering={isFlickering}
					color={isDownloadCompleted ? NewStyleColor.Green : iconsColor}
					action={action}
					data-tip={style === ActionButtonStyle.Icon}
					data-for={tooltipId}
				>
					{this.renderButtonContent()}
					{(UserAgentUtils.isDesktop() && style === ActionButtonStyle.Icon) &&
						<Tooltip id={tooltipId} text="messages.download" />
					}
				</DownloadButton>
			) :
			null;
	}
}

export default DriveItemDownloadButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/DownloadButton/index.tsx